module.exports = __webpack_public_path__ + "img/arrow-circle.8b02a6a3.svg";